import { Observable } from "rxjs";
import { Respuesta } from "../../../../../layout/investigaciones/ver-respuestas/Respuesta";
import { PreguntaDTO, RespuestaEncuesta, RespuestaUsuario } from "@DTOS";
import { CloudData } from "angular-tag-cloud-module";

export abstract class ProcesoRespuestas {
    terminoCarga$: Observable<void>;
    abstract iniciar(respuestas: RespuestaEncuesta[]): void;
    abstract iniciarTotales(respuestas: RespuestaEncuesta[]): void;
    abstract filtrar(): void;
    abstract obtenerRespuestas(pregunta: PreguntaDTO): Promise<Respuesta[] | CloudData[]>;
    abstract obtenerTotalRespuestas(): number;
    abstract obtenerTotalRespuestasMostradas(): number;
    abstract obtenerRespuestasUsuario(): RespuestaUsuario[];
    abstract obtenerRespuestasUsuarioMostradas(): RespuestaUsuario[];
}
